<template>
  <div>
    <div id="func-content">
      <div style="margin-left: 30px" class="text-danger">
        如欲修改，建議於營業時間結束後修改門市接單控管時段設定，避免影響現行門市接單計算，謝謝
      </div>
      <!-- <b-card class="bg-default-card" header="全國">
        <div class="row">
          <div class="col-md-5">
            <div class="row">
              <label class="col-md-7 control-label" for="example-select">時段可接單金額：</label>
              <div class="col-md-5">
                <input v-model="PeriodAmount" type="number" placeholder="" class="form-control" :min="PeriodAmount_min" :max="PeriodAmount_max" :disabled="!set_activity"/>
              </div>
            </div>
          </div>
          <div class="col-md-7">
              <div class="row">
                  <label class="col-md-4 control-label" for="example-select">允許接單金額超出額度：</label>
                  <div class="col-md-4">
                      <input v-model="OverAmount" type="number" placeholder="" class="form-control" :min="OverAmount_min" :max="OverAmount_max" :disabled="!set_activity"/>
                  </div>
              </div>
          </div>
        </div>
      </b-card> -->
      <fieldset>
        <legend>門市</legend>
          <div class="row px-4 pt-4">
              <label class="col-md-2" style="text-align:right">店號：</label>
              <div class="col-md-2">
                <input type="text" class="form-control" v-model="search.code" placeholder="請輸入店號">
              </div>
              <label class="col-md-2" style="text-align:right">店名：</label>
              <div class="col-md-2">
                <input type="text" class="form-control" v-model="search.name" placeholder="模糊搜尋">
              </div>
          </div>
          <div class="row px-4 pb-4">
            <label class="col-md-2" style="text-align:right">品牌：</label>
            <div class="col-md-3">
              <select
                id="brands-code"
                name="brandsCode"
                class="form-control"
                v-model="search.brandCode"
              >
              <option
                v-for="x in selectListBrands"
                v-bind:value="x.Code"
                :key="x.Code"
              >{{x.Text}}</option>
              </select>
            </div>
            <div class="col-md-3" style="text-align:right">
                <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
            </div>
          </div>
          <b-tabs card class="tab_color" v-model="search.tabIndex">
            <b-tab title="一般時段">
              <div class="row">
                <div class="table-responsive">
                  <table class="table table-bordred table-striped">
                    <thead>
                      <tr>
                        <th>項次</th>
                        <th>品牌</th>
                        <th>店號</th>
                        <th>店名</th>
                        <th>時段可接單金額</th>
                        <th>允許超出額度</th>
                        <th><button type="button" class="btn btn-warning btnByEdit" v-if="FunctionPermission > 1" @click="editByOpen('add')">新增</button></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                        <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                        <td>{{x.BrandCode}}</td>
                        <td>{{x.StoreCode}}</td>
                        <td>{{x.StoreName}}</td>
                        <td>{{x.AcceptAmount==''? '同全國' : x.AcceptAmount}}</td>
                        <td>{{x.OverAmount==''? '同全國' : x.OverAmount}}</td>
                        <td>
                          <button class='btn-circle btn-circle-ptc1' v-show='FunctionPermission > 1' @click="editByOpen('edit',x)"><span class='fas fa-pencil-alt' title="編輯"></span></button>
                          <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="showDelete(x, 'normal')" v-if="FunctionPermission > 1"><span class="fas fa-trash-alt"></span></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                  <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                </div>
              </div>
            </b-tab>
            <b-tab title="尖峰時段" @click="changeTab(1)">
              <div class="row">
                <div class="col-lg-12 mt-2">
                  <div class="table-responsive">
                    <table class="table table-bordred table-striped">
                      <thead>
                        <tr>
                          <th>項次</th>
                          <th>品牌</th>
                          <th>店號</th>
                          <th>店名</th>
                          <th>平/假日</th>
                          <th>尖峰時段</th>
                          <th>時段可接單金額</th>
                          <th><button type="button" class="btn btn-warning btnByEdit" v-if="FunctionPermission > 1" @click="editTimeByOpen('add')">新增</button></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(x, index) in itemsByHigh" :key="x.ID">
                          <td>{{pageRows * (search.currentPage1 - 1) + index + 1}}</td>
                          <td>{{x.BrandCode}}</td>
                          <td>{{x.StoreCode}}</td>
                          <td>{{x.StoreName}}</td>
                          <td>{{x.Mode==1? '平日' : x.Mode==2? '假日' : x.Mode}}</td>
                          <td>{{x.TimeStart}}-{{x.TimeEnd}}</td>
                          <td>{{x.AcceptAmount}}</td>
                          <td>
                            <button class='btn-circle btn-circle-ptc1' v-show='FunctionPermission > 1' @click="editTimeByOpen('edit',x)"><span class='fas fa-pencil-alt' title="編輯"></span></button>
                            <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="showDelete(x, 'high')" v-if="FunctionPermission > 1"><span class="fas fa-trash-alt"></span></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row" style="padding: 0 1rem">
                    <b-pagination size="md" :total-rows="totalRows1" v-model="search.currentPage1" :per-page="pageRows" @change="changePageByTime"></b-pagination>
                    <label style="margin:8px">{{startRowNum1}}到{{endRowNum1}}，總共 {{totalRows1}}筆</label>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
      </fieldset>
      <b-modal ref="mdHighTime" :no-close-on-backdrop="true" hide-footer :title="mdTitle + '尖峰時段'"  size="lg" >
        <div class="d-block">
            <div class="col-lg-12 col-12 mb-3">
              <div class="row col-lg-12" style="padding-top:10px">
                <div class="col-md-3">
                    <label class="control-label">品牌：</label>
                </div>
                <div class="col-md-9">
                  {{(afterClickBrandsCode !== search.brandCode) ? afterClickBrandsCode : search.brandCode}}
                </div>
              </div>
              <div class="row col-lg-12" style="padding-top:10px">
                <div class="col-md-3">
                    <label class="control-label">門市：</label>
                </div>
                <div class="col-md-9">
                    <multiselect v-model="timeModel.OptionStore" @remove="searchStoreSetting('')" @input="searchStoreSetting(timeModel.OptionStore.Code)" :options="allStores" :multiple="false" :custom-label="nameWithLang" group-values="Stores" group-label="City" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" v-if='mode=="add"'>
                      <span slot="noResult">查無資料</span>
                    </multiselect>
                    <label class="control-label" v-if='mode=="edit"'>{{StoreCode}}&nbsp;{{StoreName}}</label>
                    <div class="text-danger" v-if="timeModel.valid_OptionStore&&!timeModel.OptionStore">{{timeModel.valid_OptionStore}}</div>
                </div>
              </div>
              <div class="row col-lg-12" style="padding-top:10px">
                <div class="col-md-3">
                    <label class="control-label">類型：</label>
                </div>
                <div class="col-md-9">
                   <select id='timeType' name='timeType' class='form-control' v-model='timeModel.timeMode' :disabled='this.mode == "edit"' required>
                      <option disabled value=0>請選擇平假日</option>
                      <option value=1>平日</option>
                      <option value=2>假日</option>
                  </select>
                  <div class="text-danger" v-if="timeModel.valid_timeMode&&!timeModel.timeMode!=0">{{timeModel.valid_timeMode}}</div>
                </div>
              </div>
              <div class="row col-lg-12" style="padding-top:10px">
                <div class="col-md-3">
                  <label class="control-label">時段可接單金額：</label>
                </div>
                <div class="col-md-3">
                    <label class="control-label">{{showAmount}}</label>
                </div>
                <div class="col-md-3">
                    <label class="control-label">允許超出額度：</label>
                  </div>
                  <div class="col-md-3">
                    <label class="control-label">{{showOverAmount}}</label>
                  </div>
              </div>
                <div v-for="(list,index) in timeModel.listTime" :key="index">
                <hr>
                  <div class="row col-lg-12" style="padding-top:10px">
                    <div class="col-md-3">
                      <label class="control-label">尖峰時段：</label>
                    </div>
                    <div class="col-md-3">
                      <input v-model="list.startTime" type="time" placeholder="" class="form-control" />
                      <div class="text-danger" v-if="list.valid_StartTime&&!list.startTime">{{list.valid_StartTime}}</div>
                    </div>
                    <label class="control-label">-</label>
                    <div class="col-md-3">
                      <input v-model="list.endTime" type="time" placeholder="" class="form-control" />
                      <div class="text-danger" v-if="list.valid_EndTime&&!list.endTime">{{list.valid_EndTime}}</div>
                    </div>
                    <button type="button" class="btn btn-warning text-white" v-if="index==0 && mode=='add' && timeModel.listTime.length <5" @click="addListTime()">增加時段</button>
                    <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1" @click="delListTime(index)" v-if="index != 0 && mode == 'add'"><span class="fas fa-trash-alt"></span></button>
                  </div>
                  <div class="row col-lg-12" style="padding-top:10px">
                    <div class="col-md-3" />
                    <div class="col-md-9">
                      <div class="text-danger" v-if="list.valid_TimeErr">{{list.valid_TimeErr}}</div>
                    </div>
                  </div>
                  <div class="row col-lg-12" style="padding-top:10px">
                    <div class="col-md-3">
                      <label class="control-label">可接單金額：</label>
                    </div>
                    <div class="col-md-6">
                      <input v-model="list.amount" type="text" placeholder="" class="form-control" />
                      <div class="text-danger" v-if="list.valid_Amount">{{list.valid_Amount}}</div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="cog-lg-12">
                <div class="row float-right cog-lg-12">
                    <b-btn variant="primary"  @click="editTimeConfirm()">儲存</b-btn>&nbsp;&nbsp;&nbsp;&nbsp;
                    <b-btn variant="secondary"  @click="$refs.mdHighTime.hide()">取消</b-btn>&nbsp;
                </div>
            </div>
        </div>
      </b-modal>
      <b-modal ref="mdEdit" :no-close-on-backdrop="true" hide-footer :title="mdTitle" size="lg">
            <div class="d-block">
                <div class="col-lg-12 col-12 mb-3">
                    <div class="row col-lg-12" style="padding-top:10px">
                      <div class="col-md-4">
                        <label class="control-label">品牌：</label>
                      </div>
                      <div class="col-md-8">
                        {{(afterClickBrandsCode !== search.brandCode) ? afterClickBrandsCode : search.brandCode}}
                      </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                      <div class="col-md-4">
                        <label class="control-label">門市：</label>
                      </div>
                      <div class="col-md-8">
                        <multiselect v-model="model.OptionStore" :options="stores" :multiple="false" :custom-label="nameWithLang" group-values="Stores" group-label="City" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" v-if='mode=="add"'>
                          <span slot="noResult">查無資料</span>
                        </multiselect>
                        <label class="control-label" v-if='mode=="edit"'>{{StoreCode}}&nbsp;{{StoreName}}</label>
                        <div class="text-danger" v-if="valid_OptionStore&&!model.OptionStore">{{valid_OptionStore}}</div>
                      </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                      <div class="col-md-4">
                        <label class="control-label">時段可接單金額：</label>
                      </div>
                      <div class="col-md-8">
                        <input v-model="model.AcceptAmount" type="text" placeholder="" class="form-control" />
                        <div class="text-danger" v-if="valid_AcceptAmount">{{valid_AcceptAmount}}</div>
                      </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                      <div class="col-md-4">
                        <label class="control-label">允許超出額度：</label>
                      </div>
                      <div class="col-md-8">
                        <input v-model="model.OverAmount" type="text" placeholder="" class="form-control" />
                        <div class="text-danger" v-if="valid_OverAmount">{{valid_OverAmount}}</div>
                      </div>
                    </div>
                </div>
                <div class="cog-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn class="cog-lg-2" variant="primary"  @click="editConfirm()">儲存</b-btn>&nbsp;&nbsp;&nbsp;&nbsp;
                        <b-btn class="cog-lg-2" variant="secondary"  @click="editCancel()">取消</b-btn>&nbsp;
                    </div>
                </div>
            </div>
      </b-modal>
      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer :title="'刪除門市' + (delMode == 'high' ? '尖峰': '一般') + '時段'">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除 {{delMsg}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="$refs.mdDelete.hide()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>

import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      API_URL: API_URL,
      FunctionPermission: 0,
      valid_errMsg: false,
      // 門店
      search: {
        code: '',
        name: '',
        currentPage: 1,
        currentPage1: 1, //尖峰時段
        brandCode: DEFAULT_SEARCH_BRAND_CODE
      },
      model: {
        OptionStore: '',
        //ProductionTime: '',
        AcceptAmount: '',
        OverAmount: ''
      },
      ID: 0,
      StoreID: 0,
      StoreCode: '',
      StoreName: '',
      mdTitle: '',
      stores:[],
      allStores:[],
      //valid_ProductionTime: '',
      valid_AcceptAmount: '',
      valid_OverAmount: '',
      valid_OptionStore: '',
      totalRows: 0,
      totalRows1: 0, //尖峰時段
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      startRowNum1: 0, //尖峰時段
      endRowNum1: 0, //尖峰時段
      items: [],
      itemsByHigh: [],
      mode: 'add',
      timeModel:{
        OptionStore: '',
        valid_OptionStore: '',
        timeMode: 0,
        valid_timeMode: '',
        listTime: [{
          startTime: '',
          valid_StartTime: '',
          endTime: '',
          valid_EndTime: '',
          amount: 0,
          valid_Amount: '',
          valid_TimeErr: ''
        }],
      },
      // 全國
      PeriodAmount: 0,
      OverAmount: 0,
      mealItem: '',
      PeriodAmount_min: 5,
      PeriodAmount_max: 5000,
      OverAmount_min: 0,
      OverAmount_max: 2000,
      delMsg: '',
      delMode: '',
      itemsByAllStoreSetting:[],
      showAmount: '',
      showOverAmount: '',

      selectListBrands: [], // 品牌下拉選單
      afterClickBrandsCode: "",
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F20') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }
    var search = this.$route.params.search
    if (search !== undefined) {
      if (search.name !== undefined) {
        this.search = search
        this.btnQuery()
      } else {
        this.reset()
      }
    } else {
      this.reset()
    }
    this.PublicQuery()
    this.querySelectListBrands()
  },
  methods: {
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.brandCode = DEFAULT_SEARCH_BRAND_CODE

      this.btnQuery()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.search.currentPage1 = 1
      this.query()
      this.getStoreTimeOrderSetting()
    },
    query () {
      var name, code, page, pageRows,brandCode

        name = this.search.name
        code = this.search.code
        page = this.search.currentPage
        pageRows = this.pageRows
        brandCode = this.search.brandCode

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getpageStoreOrderSetting/v1', {
        code: code,
        name: name,
        page: page,
        pageRows: pageRows,
        brandCode: brandCode,
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = page // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows;
            this.itemsByAllStoreSetting = response.data.dataByAllStore
            this.afterClickBrandsCode = this.search.brandCode
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    changePageByTime (page) {
      this.search.currentPage1 = page
      this.getStoreTimeOrderSetting()
    },
    showDelete (item, Mode) {
      this.ID = item.ID
      this.delMode = Mode
      if (this.delMode == 'high') {
        this.delMsg = item.StoreName + '-' + (item.Mode == 1 ? '平日' : '假日') + '(' + item.TimeStart + '-' + item.TimeEnd + ')'
      } else {
        this.delMsg = item.StoreName
      }
      this.$refs.mdDelete.show()
    },
    //尋找門市是否有一般設定
    searchStoreSetting(storecode) {
      if (!storecode) {
        this.showOverAmount = ''
        this.showAmount = ''
        return
      }
      let obj
      if (this.itemsByAllStoreSetting.length > 0) {
        obj = this.itemsByAllStoreSetting.find(o => o.StoreCode === storecode)
        console.log(obj)
      }
      if (!obj) {
        this.showAmount = this.PeriodAmount.toString() +'(同全國)'
        this.showOverAmount = this.OverAmount.toString() +'(同全國)'
      } else {
        this.showAmount = (!obj.AcceptAmount) ? this.PeriodAmount.toString() +'(同全國)'  : obj.AcceptAmount
        this.showOverAmount = (!obj.OverAmount) ? this.OverAmount.toString() +'(同全國)'  : obj.OverAmount
      }
    },
    // 按下列表編輯按鈕
    editTimeByOpen (mode,item) {
      this.editTimeClear()

      this.mode = mode
      if (mode == 'edit') {
        this.searchStoreSetting(item.StoreCode)
        this.ID = item.ID
        this.BrandCode = item.BrandCode
        this.StoreID = item.StoreID
        this.StoreCode = item.StoreCode
        this.StoreName = item.StoreName
        this.timeModel.timeMode = item.Mode
        this.timeModel.listTime = [{
          startTime: item.TimeStart,
          endTime: item.TimeEnd,
          amount: item.AcceptAmount,
          valid_StartTime: '',
          valid_EndTime: '',
          valid_Amount: '',
          valid_TimeErr: ''
        }]
        this.mdTitle = '編輯'
      } else {
        this.mdTitle = '新增'
        this.getAllStores(0)
        if (this.afterClickBrandsCode != this.search.brandCode){
          this.query()
          this.getStoreTimeOrderSetting()
        }
      }
      this.$refs.mdHighTime.show()
    },
    // 按下列表編輯按鈕
    editByOpen (mode,item) {
      this.editClear()
      this.mode = mode
      if (mode == 'edit') {
        this.ID = item.ID
        this.BrandCode = item.BrandCode
        this.StoreID = item.StoreID
        this.StoreCode = item.StoreCode
        this.StoreName = item.StoreName
        this.model.AcceptAmount = item.AcceptAmount
        this.model.OverAmount = item.OverAmount
        this.mdTitle = '修改店家設定(空白即同全國)'
      } else {
        this.mdTitle = '新增店家設定(空白即同全國)'
        this.getAllStores(1)
        if (this.afterClickBrandsCode != this.search.brandCode){
          this.query()
          this.getStoreTimeOrderSetting()
        }
      }
      this.$refs.mdEdit.show()
    },
    editCancel () {
      this.$refs.mdEdit.hide()
      this.editClear()
    },
    editTimeClear () {
      this.ID = '',
      this.showAmount = '',
      this.showOverAmount = '',
      this.StoreID = 0,
      this.StoreCode = '',
      this.timeModel.OptionStore = '',
      this.timeModel.valid_OptionStore = ''
      this.timeModel.timeMode = 0,
      this.timeModel.valid_timeMode = '',
      this.timeModel.listTime = [{
          startTime: '',
          valid_StartTime: '',
          endTime: '',
          valid_EndTime: '',
          amount: 0,
          valid_Amount: '',
          valid_TimeErr: ''
        }]
    },
    editClear () {
      this.ID = '',
      this.StoreID = 0,
      this.StoreCode = '',
      this.model.OptionStore = '',
      this.model.AcceptAmount = '',
      this.model.OverAmount = '',
      this.valid_OptionStore = ''
      this.valid_AcceptAmount = ''
      this.valid_OverAmount = ''
    },
    //取得門市下拉選單
    getAllStores (Status) {
      this.$parent.Loading = true      
      return axios.post(API_URL + '/web/shopping/getallstoresTowLevel/v1', {
        status: Status,
        brandCode: [this.search.brandCode]
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            if (Status == 1){
              this.stores = response.data.data
            } else {
              this.allStores = response.data.data
            }
            console.log(this.stores)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '門市資訊讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '門市資訊讀取異常')
          console.log(error)
        })
    },
    editConfirm () {
      this.valid_errMsg = false
      if (this.mode == 'add') {
        if (this.model.OptionStore === undefined || this.model.OptionStore == null || this.model.OptionStore.length <= 0) {
          this.valid_errMsg = true
          this.valid_OptionStore = '門市為必選'
        } else {
          this.valid_OptionStore = ''
        }
      }
      var numReg = /^[-+]?[0-9]+$/
      var numRe = new RegExp(numReg)
/*       if (this.model.ProductionTime.length > 0) {
        if (!numRe.test(this.model.ProductionTime)) {
          this.valid_errMsg = true
          this.valid_ProductionTime = '請輸入數字'
        } else if (this.model.ProductionTime < this.MakeMealTime_min || this.model.ProductionTime > this.MakeMealTime_max ) {
          this.valid_errMsg = true
          this.valid_ProductionTime = '請輸入' + this.MakeMealTime_min + '~' + this.MakeMealTime_max
        } else if (this.model.ProductionTime % 5 != 0 ) {
          this.valid_errMsg = true
          this.valid_ProductionTime = '請以5分鐘為單位'
        } else {
          this.valid_ProductionTime = ''
        }
      } else {
        this.valid_ProductionTime = ''
      } */

      if (this.model.AcceptAmount.length > 0) {
        if (!numRe.test(this.model.AcceptAmount)) {
          this.valid_errMsg = true
          this.valid_AcceptAmount = '請輸入數字'
        } else if (this.model.AcceptAmount < this.PeriodAmount_min || this.model.AcceptAmount > this.PeriodAmount_max ) {
          this.valid_errMsg = true
          this.valid_AcceptAmount = '請輸入' + this.PeriodAmount_min + '~' + this.PeriodAmount_max
        } else {
          this.valid_AcceptAmount = ''
        }
      } else {
        this.valid_AcceptAmount = ''
      }

      if (this.model.OverAmount.length > 0) {
        if (!numRe.test(this.model.OverAmount)) {
          this.valid_errMsg = true
          this.valid_OverAmount = '請輸入數字'
        } else if (this.model.OverAmount < this.OverAmount_min || this.model.OverAmount > this.OverAmount_max ) {
          this.valid_errMsg = true
          this.valid_OverAmount = '請輸入' + this.OverAmount_min + '~' + this.OverAmount_max
        } else {
          this.valid_OverAmount = ''
        }
      } else {
        this.valid_OverAmount = ''
      }

      if (!this.model.AcceptAmount&&!this.model.OverAmount) {
        this.valid_errMsg = true
        miniToastr.error('請至少輸入一個金額或時間')
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      if (this.mode == 'add') {
        this.addSave()
      } else {
        this.editSave()
      }
    },
    editTimeConfirm () {
      this.valid_errMsg = false
      if (this.mode == 'add') {
          this.timeModel.valid_OptionStore = ''
          this.timeModel.valid_timeMode = ''
        if (this.timeModel.OptionStore === undefined || this.timeModel.OptionStore == null || this.timeModel.OptionStore.length <= 0) {
          this.valid_errMsg = true
          this.timeModel.valid_OptionStore = '門市為必選'
        }
        if (this.timeModel.timeMode === 0) {
          this.valid_errMsg = true
          this.timeModel.valid_timeMode = '請選擇類型'
        }
      }
      var numReg = /^[-+]?[0-9]+$/
      var numRe = new RegExp(numReg)
      var item
      for (var index in this.timeModel.listTime) {
        item = this.timeModel.listTime[index]
        item.valid_StartTime = ''
        item.valid_EndTime = ''
        item.valid_Amount = ''
        item.valid_TimeErr = ''

        //檢核必輸
        if (item.startTime === '') {
          this.valid_errMsg = true
          item.valid_StartTime = '請輸入時段(起)'
        }
        if (item.endTime === '') {
          this.valid_errMsg = true
          item.valid_EndTime = '請輸入時段(迄)'
        }
        if (!item.valid_StartTime && !item.valid_EndTime && item.startTime>=item.endTime) {
          this.valid_errMsg = true
          item.valid_TimeErr = '時段(起)必須大於(迄)'
        }
        if (!numRe.test(item.amount) || item.amount < this.PeriodAmount_min || item.amount > this.PeriodAmount_max ) {
          this.valid_errMsg = true
          item.valid_Amount = '請輸入數字' + this.PeriodAmount_min + '~' + this.PeriodAmount_max
        }
      }
      if (this.valid_errMsg== false) {
        for (var index in this.timeModel.listTime) {
          var item = this.timeModel.listTime[index]
          var startTime = new Date('2001/01/01 ' + item.startTime + ':00')
          var endTime = new Date('2001/01/01 ' + item.endTime + ':59')

          for (var i in this.timeModel.listTime) {
            var itemCheck = this.timeModel.listTime[i]
            var startTimeCheck = new Date('2001/01/01 ' + itemCheck.startTime + ':00')
            var endTimeCheck = new Date('2001/01/01 ' + itemCheck.endTime + ':59')
            if (index == i) {
              continue
            }
            if ((startTime >= startTimeCheck && startTime <= endTimeCheck) ||
                (endTime >= startTimeCheck && endTime <= endTimeCheck) ||
                (startTime >= startTimeCheck && endTime <= endTimeCheck) ||
                (startTime <= startTimeCheck && endTime >= endTimeCheck)) {
                this.valid_errMsg = true
                item.valid_TimeErr = '時段重複輸入，請重新輸入'
                break
            }
          }
        }
      }

      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      if (this.mode == 'add') {
        this.addTimeSave()
      } else {
        this.editTimeSave()
      }
    },
    addListTime () {
      if (this.timeModel.listTime.length < 5) {
        let cope = {
          startTime: '',
          valid_StartTime: '',
          endTime: '',
          valid_EndTime: '',
          amount: 0,
          valid_Amount: '',
          valid_TimeErr: ''
        }
        this.timeModel.listTime.push(cope)
      }
    },
    delListTime (index) {
      this.timeModel.listTime.splice(index, 1)
    },
    addSave () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/StoreOrderSettingCreate/v1', {
        // menuCategoryID: this.$route.params.menuid,
        optionStore: this.model.OptionStore,
        //productionTime: this.model.ProductionTime,
        acceptAmount: this.model.AcceptAmount,
        overAmount: this.model.OverAmount,
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.query ()
            miniToastr.success('新增成功')
            this.editCancel ()
            this.getAllStores(1)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    editTimeSave () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/StoreTimeOrderSettingUpdate/v1', {
        id: this.ID,
        storeCode: this.StoreCode,
        timeStart: this.timeModel.listTime[0].startTime,
        timeEnd:this.timeModel.listTime[0].endTime,
        amount:Number(this.timeModel.listTime[0].amount),
        mode: this.timeModel.timeMode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.$refs.mdHighTime.hide()
            this.getStoreTimeOrderSetting()
            miniToastr.success('修改成功')
            this.editCancel ()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            if (response.data.result === '1118') {
              this.editTimeShowMsg()
            }
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
        })
    },
    editTimeShowMsg () {
      this.timeModel.listTime[0].valid_TimeErr = '時段重複，請重新輸入'
    },
    addTimeSave () {
      this.$parent.Loading = true
      var lstAdd = []
      for (var index in this.timeModel.listTime) {
        var item = this.timeModel.listTime[index]
        lstAdd.push({ timeStart:item.startTime , timeEnd: item.endTime , amount:Number(item.amount)})
      }

      return axios.post(API_URL + '/web/shopping/StoreTimeOrderSettingCreate/v1', {
        storeCode: this.timeModel.OptionStore.Code,
        mode: Number(this.timeModel.timeMode),
        data: lstAdd
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.$refs.mdHighTime.hide()
            this.getStoreTimeOrderSetting()
            miniToastr.success('新增成功')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增錯誤')
            if (response.data.data) {
              this.addTimeRepeat(response.data.data)
            }
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增錯誤')
        })
    },
    editSave () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/StoreOrderSettingUpdate/v1', {
        // menuCategoryID: this.$route.params.menuid,
        id: this.ID,
        storeID: Number(this.StoreID),
        storeCode: this.StoreCode,
        //productionTime: this.model.ProductionTime,
        acceptAmount: this.model.AcceptAmount,
        overAmount: this.model.OverAmount
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.query ()
            miniToastr.success('修改成功')
            this.editCancel ()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    delOrderTimeSetting() {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/StoreTimeOrderSettingDelete/v1', {
        id: this.ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.getStoreTimeOrderSetting()
            miniToastr.success('已刪除')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
        })
    },
    delOrderSetting() {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/StoreOrderSettingDelete/v1', {
        id: this.ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.query ()
            miniToastr.success('已刪除')
            this.getAllStores(1)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    delConfirm () {
      this.$refs.mdDelete.hide()
      if (this.delMode == 'high') {
        this.delOrderTimeSetting() //尖峰時段
      } else {
        this.delOrderSetting()
      }
    },
    PublicQuery () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getOrderSettingMeal/v1', {
        mode: 'mealMode'
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.mealItem = response.data.data
            this.PeriodAmount = this.mealItem.periodAmount
            this.OverAmount = this.mealItem.overAmount
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    // 取得尖峰時段
    getStoreTimeOrderSetting () {
      var page
      page = this.search.currentPage1

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getStoreTimeOrderSetting/v1', {
        storeCode: this.search.code,
        storeName: this.search.name,
        page: page,
        pageRows: this.pageRows,
        brandCode: this.search.brandCode,
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          if (response.data.result === '0000') {
            this.itemsByHigh = response.data.data
            this.totalRows1 = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage1 = page // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum1 = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage1 - 1) + 1;
            this.endRowNum1 = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage1 * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage1 * this.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    addTimeRepeat (array) {
      for (let i = 0; i < array.length; i++) {
        this.timeModel.listTime[array[i].index].valid_TimeErr = '時段重複，請重新輸入'
      }
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  }
}
</script>
<style scoped>
fieldset {
  padding: 8px 22px 18px;
  margin: 3px 12px 18px;
  border: 1px solid #519b39;
}
legend {
  padding: .2em;
  border: 0;
  width: auto;
  color: #519b39;
}
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
.btnByEdit, .btnByEdit:active, .btnByEdit:focus {
  color: #fff !important;
  background-color: #519B39 !important;
  border-color: #519B39 !important;
}

.btnByEdit:hover {
  color: #fff !important;
  background-color: #138045 !important;
  border-color: #138045 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/ordersetting/StoreOrderSetting.vue